import styles from "./style.module.css";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "../../../../../../../../context/themeContext";

const Skill = ({ skill, index, activeSkill, setActiveSkill }) => {
  const { theme, darkMode } = useTheme();
  const isActive = skill?.id === activeSkill?.id && skill.id !== undefined;

  const handleItemClick = () => {
    if (!isActive) setActiveSkill(skill);
  };

  return (
    <Box className={styles.skill} key={index}>
      <Box
        className={styles.skillNum}
        sx={{
          background: isActive
            ? theme.palette.primary.main
            : theme.palette.lightgrey.lightgrey00,
        }}
        onClick={() => handleItemClick(index)}
      >
        {isActive ? (
          <img src={skill?.active_image} alt="" />
        ) : (
          <img src={skill.in_active_image} alt="" />
        )}
      </Box>
      <Box className={styles.text}>
        <Typography
          variant="h4"
          sx={{
            color: isActive
              ? darkMode
                ? "#FFF"
                : theme.palette.primary.main
              : darkMode
              ? theme.palette.darkgrey.darkgrey300
              : theme.palette.darkgrey.darkgrey600,
            fontSize: {
              xs: "12px",
            },
            fontWeight: "500",
          }}
        >
          {skill.category}
        </Typography>
      </Box>
    </Box>
  );
};

export default Skill;
